<template>
  <div>
    <form-field-input
      label="Name"
      v-model="form.name"
      :validation-errors="validationErrors.name"
    ></form-field-input>

    <form-field-textarea
      label="Description"
      v-model="form.description"
      :validation-errors="validationErrors.description"
    ></form-field-textarea>
    <template v-if="form.type === ENUMS.CallScriptTypeEnum.Contact.value">
      <form-field-collection
        v-model="form.contact_tags"
        :options="$store.getters.contactTags"
        label="Attach Tags"
        help-text="Note: Tags must be created via Contact Settings before attaching to a contact"
        field="label"
        placeholder="Select tag"
        icon="label"
        :validation-errors="validationErrors.contact_tags"
      ></form-field-collection>

      <form-field-select-contact-types v-model="form.contact_types" :validation-errors="validationErrors.contact_types"/>
    </template>
    <template v-else>
      <form-field-select-campaign
        label="Default Campaign"
        v-model="form.campaign_id"
        :validation-errors="validationErrors.campaign_id"
        help-text="Campaign to assign to the new Leads created by this Webhook"
      ></form-field-select-campaign>

      <form-field-select-users
        label="Default User"
        v-model="form.user_id"
        :validation-errors="validationErrors.user_id"
        help-text="User to assign new Leads created by this Call Script"
      ></form-field-select-users>

      <form-field-select-status
        label="Default Status"
        v-model="form.status_id"
        :validation-errors="validationErrors.status_id"
        :required="true"
        help-text="Status to place new Leads created by this Call Script"
      ></form-field-select-status>

      <form-field-select-temperature
        label="Default Temperature"
        v-model="form.temperature"
        :validation-errors="validationErrors.temperature"
        help-text="Temperature to set for new Leads created by this Call Script"
      ></form-field-select-temperature>
    </template>

    <form-field-switch
      label="Status"
      v-model="form.status"
      :true-value="ENUMS.CallScriptStatusEnum.Active.value"
      :false-value="ENUMS.CallScriptStatusEnum.Inactive.value"
      :validation-errors="validationErrors.status"
      description="You can turn off this call script if you no longer want to allow people to use the form"
    ></form-field-switch>

  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import {ENUMS} from "../services/enums";

export default {
  name: "CallScriptForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        name: '',
        description: '',
        contact_tags: [],
        contact_types: [],
        status: '',
        campaign_id: null,
        user_id: null,
        status_id: this.$store.getters["pipeline/statuses"].first().id,
        temperature: ENUMS.TemperatureEnum.None.value,
      },
    }
  },
  created() {
    this.form = (this.formData) ? this.$utils.clone({...this.defaultForm, ...this.formData}) : this.$utils.clone(this.defaultForm);
  },
  methods: {
    update() {
      return this.$api.callScripts.update(this.form)
      .then((res) => {
        this.$buefy.toast.open({
          message: res.data,
          type: 'is-success'
        })

        return res;
      });
    },
    delete() {
      return this.$api.callScripts.delete(this.form.id)
      .then(res => {
        this.$buefy.toast.open({
          message: res.data,
          type: 'is-success'
        });

        return res;
      });
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
